/**
 * Vehicle damage type values
 */
export enum VehicleDamageTypeEnum {
	IN_PARK = 'in_park',
	COLLISION = 'collision',
	VANDALISM = 'vandalism',
	THEFT = 'theft',
	OTHER = 'other',
	OFF_ROAD = 'off_road',
}
